<div>
    <!-- <label class="input-text" for="nombre">
{{'categories.selecciona' | translate}}
</label> -->
    <!-- <ng-select (change)="change($event)" [items]="list" 
        (scrollToEnd)="scrollTablet()" [searchable]="true" bindLabel="name" bindValue="id"
         class="input-text w-56 max-w-full" style="height:42px;padding-top: 0.65rem;" 
         placeholder="{{'categories.elegir' | translate}}">
    </ng-select> -->
    <ng-container >
        <ng-select (change)="change($event)"  (scrollToEnd)="scrollTablet()" [searchable]="true" bindLabel="name" bindValue="id" class="input-text w-56 max-w-full" style="height:42px;padding-top: 0.65rem;" placeholder="{{'categories.elegir' | translate}}">
            <ng-option *ngFor="let ctg of list " [value]="ctg" >
                <span [ngClass]="[ctg.isParent ? 'bg-dark-gris-base text-white w-full block p-2 ' : ctg.isParentWithoutSub ? 'pl-0' : 'pl-4']">
                   <span *ngIf="!ctg.isParent && !ctg.isParentWithoutSub ">- </span> {{ ctg.name }}
                </span>
              </ng-option>
        </ng-select>
    </ng-container>

</div>